import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withRouter } from "react-router-dom";
import "./SensorsHome.scss";
import state from "../../common/state/state";
import sensorsHome from "../../assets/images/sensors-home-2.svg";
import PowerTrainDropdown from "./Dropdowns/PowerTrainDropdown/PowerTrainDropdown";
import GenericDropdown from "./Dropdowns/GenericDropdown/GenericDropdown";

class SensorsHome extends Component {
  /* TODO never to this, fix this */
  state = state;
  pageRef = React.createRef();

  componentDidMount() {
    this.props.updatePageDimensions(1010, 560);
  }

  handleLink = (path) => {
    this.props.history.push(path);
  };

  handleDropdown = (prop) => {
    let showDropdown = this.state.showDropdown;
    for (const entry in showDropdown) {
      if (entry === prop) {
        showDropdown[prop] = !showDropdown[prop];
      } else {
        showDropdown[entry] = false;
      }
    }
    this.setState({ showDropdown: showDropdown });
  };

  handleDropdownIcon = (clicked) => {
    return clicked ? (
      <FontAwesomeIcon icon="chevron-circle-right" />
    ) : (
      <FontAwesomeIcon icon="chevron-circle-up" />
    );
  };

  render() {
    const {
      powertrain,
      safety,
      bodyComfort,
      consumerApplications,
      eBikes2Wheeler,
      robotics,
      drones,
    } = this.state.showDropdown;

    const {
      col_one_color,
      col_two_color,
      safetyContent,
      bodyComfortContent,
      consumerApplicationsContent,
      eBikes2WheelerContent,
      roboticsContent,
      dronesContent,
    } = this.state.dropdownContent;

    return (
      <div className="SensorsHome" ref={this.pageRef}>
        <div className="main-header">
          <h1>
            Infineon XENSIV™ solutions <br /> from application to sensor
          </h1>
          <div>
            <img src={sensorsHome} alt="Section header" />
          </div>
        </div>
        <div className="col-1">
          <h2>Automotive applications</h2>
          <div className="buttonsWrapper">
            <div className="button">
              <div className="flex-wrapper">
                <span onClick={() => this.handleDropdown("powertrain")}>
                  {this.handleDropdownIcon(!powertrain)}
                </span>
                <span onClick={() => this.handleDropdown("powertrain")}>
                  Powertrain
                </span>
                {powertrain && (
                  <PowerTrainDropdown
                    onClickLi={() => this.handleDropdown("powertrain")}
                  />
                )}
              </div>
            </div>
            <div
              className="button"
              onClick={() => this.handleDropdown("safety")}
            >
              <div className="flex-wrapper">
                {this.handleDropdownIcon(!safety)}
                <span>Safety</span>
                {safety && (
                  <GenericDropdown
                    width="16.6rem"
                    rows={safetyContent}
                    color={col_one_color}
                    history={this.props.history}
                  />
                )}
              </div>
            </div>
            <div
              className="button"
              onClick={() => this.handleDropdown("bodyComfort")}
            >
              <div className="flex-wrapper">
                {this.handleDropdownIcon(!bodyComfort)}
                <span>Body and Comfort</span>
                {bodyComfort && (
                  <GenericDropdown
                    width="15.4rem"
                    rows={bodyComfortContent}
                    color={col_one_color}
                    history={this.props.history}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        {/* TODO make this with a map or something */}
        <div className="col-2">
          <h2>Industrial/Consumer applications</h2>
          <div className="buttonsWrapper">
            <div
              className="button doubleRow"
              onClick={() => {
                this.handleLink("/industrial-drives");
                this.handleDropdown("");
              }}
            >
              <FontAwesomeIcon icon="chevron-circle-right" className="icon" />
              <span>
                Industrial
                <br /> drives
              </span>
            </div>
            <div
              className="button doubleRow"
              onClick={() => this.handleDropdown("consumerApplications")}
            >
              {this.handleDropdownIcon(!consumerApplications)}
              <span>
                Consumer <br /> applications
              </span>
              {consumerApplications && (
                <GenericDropdown
                  width="16.6rem"
                  rows={consumerApplicationsContent}
                  color={col_two_color}
                  history={this.props.history}
                  doubleHeight
                />
              )}
            </div>
            <div
              className="button doubleRow"
              onClick={() => this.handleDropdown("eBikes2Wheeler")}
            >
              {this.handleDropdownIcon(!eBikes2Wheeler)}
              <span>
                eBikes and
                <br /> 2-Wheeler
              </span>
              {eBikes2Wheeler && (
                <GenericDropdown
                  width="16.6rem"
                  rows={eBikes2WheelerContent}
                  color={col_two_color}
                  history={this.props.history}
                  doubleHeight
                />
              )}
            </div>
            <div
              className="button"
              onClick={() => this.handleDropdown("robotics")}
            >
              <div className="flex-wrapper">
                {this.handleDropdownIcon(!robotics)}
                <span>Robotics</span>
                {robotics && (
                  <GenericDropdown
                    width="15.4rem"
                    rows={roboticsContent}
                    color={col_two_color}
                    history={this.props.history}
                  />
                )}
              </div>
            </div>
            <div
              className="button"
              onClick={() => this.handleDropdown("drones")}
            >
              <div className="flex-wrapper">
                {this.handleDropdownIcon(!drones)}
                <span>Drones</span>
                {drones && (
                  <GenericDropdown
                    width="16.6rem"
                    rows={dronesContent}
                    color={col_two_color}
                    history={this.props.history}
                  />
                )}
              </div>
            </div>
            <div
              className="button doubleRow"
              onClick={() => {
                this.handleLink("/wearables-and-hearables");
                this.handleDropdown("");
              }}
            >
              <FontAwesomeIcon icon="chevron-circle-right" className="icon" />
              <span>
                Wearables and <br /> hearables
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SensorsHome);
